<template>
  <div class="flex flex-wrap mb-2" :style="(guideStep > 0 && guideStep <= 6) || guideStep === 2001 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <div>
        <span class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingMethod']['title']}}</span>
        <span class="text-grap-700 text-sm">（{{lang['components']['Event']['MarketingMethod']['currency_text']}}：{{ currencyListData.currency }}）</span>
        <i
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
          v-tooltip.top="`${lang['components']['Event']['MarketingMethod']['title_info']}`"
        ></i>
        <button
          v-if="!editPageType"
          id="marketingMethod"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['MarketingMethod']['video_teaching']}}
        </button>
      </div>
      <div v-if="false" class="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <!-- 新手教學 -->
        <div
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_KW || guideStep === 2 }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingMethod']['kw_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${budgetKWInfo}`"
              ></i>
            </div>
            <!-- 新手教學 -->
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_KW" class="flex-none" :class="{ 'ring-4 border-blue-400': guideStep === 6 }"/>
          </div>
          <div
            class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200"
          >
            <input
              :disabled="!viewDatalistData.Target_KW || editPageType"
              class="w-full text-sm outline-none focus:outline-none bg-transparent"
              style="text-align: right"
              type="text" v-model="Budget_KW"
              oninput = "value=value.replace(/[^\d]/g,'')"
              :placeholder="currencyListData.currency+'/day'"
              @blur="budgetKW(Budget_KW)"
            />
            <!-- <span v-if="Budget_KW == ''" class="text-xs text-gray-400">{{ currencyListData.currency }}/day</span> -->
          </div>
        </div>
        <!-- 新手教學 -->
        <div
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_DM || guideStep === 3 }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingMethod']['dm_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${budgetDMInfo}`"
              ></i>
            </div>
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_DM" class="flex-none" />
          </div>

          <div
            class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200"
          >
            <input
              :disabled="!viewDatalistData.Target_DM || editPageType"
              class="w-full text-sm outline-none focus:outline-none bg-transparent"
              style="text-align: right"
              type="text" v-model="Budget_DM"
              oninput = "value=value.replace(/[^\d]/g,'')"
              :placeholder="currencyListData.currency+'/day'"
              @blur="budgetDM(Budget_DM)"
            />
            <!-- <span v-if="Budget_DM == ''" class="text-xs text-gray-400">{{ currencyListData.currency }}/day</span> -->
          </div>
        </div>        
        <!-- 新手教學 -->
        <div
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_LA || guideStep === 4 }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingMethod']['la_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${budgetLAInfo}`"
              ></i>
            </div>
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_LA" class="flex-none" />
          </div>

          <div
            class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200"
          >
            <input
              :disabled="!viewDatalistData.Target_LA || editPageType"
              class="w-full text-sm outline-none focus:outline-none bg-transparent"
              style="text-align: right"
              type="text" v-model="Budget_LA"
              oninput = "value=value.replace(/[^\d]/g,'')"
              :placeholder="currencyListData.currency+'/day'"
              @blur="budgetLA(Budget_LA)"
            />
            <!-- <span v-if="Budget_LA == ''" class="text-xs text-gray-400">{{ currencyListData.currency }}/day</span> -->
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <!-- 新手教學 -->
        <div
          v-if="false"
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_RT || guideStep === 5 }"
          class="remarketing w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingMethod']['rt_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${budgetRTInfo}`"
              ></i>
            </div>
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_RT" class="flex-none" />
          </div>

          <div
            class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200"
          >
            <input
              :disabled="!viewDatalistData.Target_RT || editPageType"
              class="w-full text-sm outline-none focus:outline-none bg-transparent"
              style="text-align: right"
              type="text" v-model="Budget_RT"
              oninput = "value=value.replace(/[^\d]/g,'')"
              :placeholder="currencyListData.currency+'/day'"
              @blur="budgetRT(Budget_RT)"
            />
            <!-- <span v-if="Budget_RT == ''" class="text-xs text-gray-400">{{ currencyListData.currency }}/day</span> -->
            <!-- <MultiSelect
              v-model="viewDatalistData.retargeting"
              :disabled="!viewDatalistData.Target_RT"
              :options="remarketingSelectList"
              optionLabel="text"
              optionValue="code"
              class="border-0"
            /> -->
          </div>
        </div>
        <!-- <div
          v-if="viewDatalistData.use_confldential_audience_status == 1"
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_CF }"
          class="w-full space-y-2 rounded-xl border p-2"
        > -->
        <div
          v-if="false"
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_CF }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingMethod']['cf_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${budgetLAInfo}`"
              ></i>
            </div>
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_CF" class="flex-none" />
          </div>

          <div
            class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200"
          >
            <input
              :disabled="!viewDatalistData.Target_CF || editPageType"
              class="w-full text-sm outline-none focus:outline-none bg-transparent"
              style="text-align: right"
              type="text" v-model="Budget_CF"
              oninput = "value=value.replace(/[^\d]/g,'')"
              :placeholder="currencyListData.currency+'/day'"
              @blur="budgetCF(Budget_CF)"
            />
          </div>
        </div>
        <div
          v-if="false"
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_AD || guideStep === 2001 }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">{{lang['components']['Event']['MarketingMethod']['ad_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="'預算上限要大於目標成本 10 倍'"
              ></i>
            </div>
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_AD" class="flex-none" />
          </div>

          <div class="flex">
            <div class="w-full bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 mr-2">
              <input
                :disabled="!viewDatalistData.Target_AD || editPageType"
                class="w-full text-sm outline-none focus:outline-none bg-transparent"
                style="text-align: right"
                type="text" v-model="Budget_AD_min"
                oninput = "value=value.replace(/[^\d]/g,'')"
                :placeholder="currencyListData.currency+'/day'"
                @blur="budgetAD_min(Budget_AD_min)"
              />
            </div>
              ~
            <div class="w-full bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 ml-2">
              <input
                :disabled="!viewDatalistData.Target_AD || editPageType"
                class="w-full text-sm outline-none focus:outline-none bg-transparent"
                style="text-align: right"
                type="text" v-model="Budget_AD_max"
                oninput = "value=value.replace(/[^\d]/g,'')"
                :placeholder="currencyListData.currency+'/day'"
                @blur="budgetAD_max(Budget_AD_max)"
              />
            </div>
          </div>
        </div>
        <div
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_AC }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">{{ lang['components']['Event']['MarketingMethod']['advantage_title'] }}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="lang['components']['Event']['MarketingMethod']['advantage_tooltip']"
              ></i>
            </div>
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_AC" class="flex-none" />
          </div>
          <div
            class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200"
          >
            <input
              :disabled="!viewDatalistData.Target_AC || editPageType"
              class="w-full text-sm outline-none focus:outline-none bg-transparent"
              style="text-align: right"
              type="text" v-model="Budget_AC"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="currencyListData.currency+'/day'"
              @blur="budgetAC(Budget_AC)"
            />
          </div>
        </div>
        <div
          :class="{ 'ring-4 border-blue-400': viewDatalistData.Target_CR }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">自定義規則</span>
            </div>
            <InputSwitch :disabled="editPageType" v-model="viewDatalistData.Target_CR" class="flex-none" />
          </div>

          <div
            class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 bg-gray-200"
          >
            <input
              disabled="true"
              class="w-full text-sm outline-none focus:outline-none bg-transparent"
              style="text-align: right"
              :placeholder="currencyListData.currency+'/day'"
            />
          </div>
        </div>
        <div
          v-if="false"
          v-for="(item, index) in otherCustomTitle" :key="index"
          :class="{ 'ring-4 border-blue-400': item.selected }"
          class="w-full space-y-2 rounded-xl border p-2"
        >
          <div class="flex">
            <div class="flex-grow text-sm">
              <span class="text-grap-700 align-middle">其它自定義規則</span>
            </div>
            <InputSwitch :disabled="editPageType" v-model="item.selected" @change="selectedOtherCust(item.selected, index)" class="flex-none" />
            <img class="w-4 h-4 cursor-pointer ml-2" src="/img/clear.5937fadd.svg" v-tooltip.top="'刪除此自定義規則'" @click="hideCustom(item.title, item.main_campaign_id, item.selected)">
          </div>

          <div
            class=" bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200"
          >
            {{item.title}}
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div v-show="viewDatalistData.Target_CR == false" class="bg-blue-500 rounded-xl space-y-1 px-4 py-2 text-white">
        <span>{{lang['components']['Event']['MarketingMethod']['total_text']}}<span v-if="viewDatalistData.Target_AD == true">{{lang['components']['Event']['MarketingMethod']['total_AD_text']}}</span></span>
        <div class="flex flex-wrap justify-between text-2xl">
          <span>{{ viewDatalistData.daily_budget }}</span>
          <span>{{ currencyListData.currency }}/day</span>
        </div>
      </div>
    </div>
    <!-- 新手教學 -->
    <div v-if="guideStep >= 1 && guideStep <= 6" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
import InputSwitch from "primevue/inputswitch";
import MultiSelect from "primevue/multiselect";
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'

export default {
  name: "MarketingMethod",
  components: {
    InputSwitch,
    MultiSelect
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: -1
    },
    teachingId: {
      type: Number,
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: Object
    },
    currencyList: {
      type: Object
    },
    goalsObjective: {
      type: String
    },
    lang: {
      type: Object
    },
    youtubeClose: {
      type: Boolean
    },
    otherCustomTitle: {
      type: Object,
      default: []
    },
  },
  data() {
    return {
      interest: false,
      age: false,
      audience: false,
      remarketing: true,
      remarketingSelect: ["web", "interact"],
      remarketingSelectList: [
        { text: "網頁再行銷", code: "web" },
        { text: "粉絲專再行銷", code: "fan" },
        { text: "互動再行銷", code: "interact" }
      ],
      Budget_KW: '',
      Budget_DM: '',
      Budget_LA: '',
      Budget_RT: '',
      Budget_CF: '',
      Budget_AD_min: '',
      Budget_AD_max: '',
      Budget_AC: '',
      budgetKWInfo: '',
      budgetDMInfo: '',
      budgetLAInfo: '',
      budgetRTInfo: '',
      x: 0,
      y: 0,
      h: 200,
      w: 320,
      active: false,
      src: "https://www.youtube.com/watch?v=VMMjP-UF6BY",
      vars: {
        rel: 0,
        start: 0,
        end: 0,
      },
      view_youtube: false,
      otherCustomize: false
    };
  },
  watch:{
    'lang':function(v){
    //  console.log('marketingmethod watch this.lang');
    //  console.log(this.lang);
      this.remarketingSelectList = [
        { text: this.lang['components']['Event']['MarketingMethod']['remarketingSelectList']['web_text'], code: "web" },
        { text: this.lang['components']['Event']['MarketingMethod']['remarketingSelectList']['fan_text'], code: "fan" },
        { text: this.lang['components']['Event']['MarketingMethod']['remarketingSelectList']['interact_text'], code: "interact" }
      ];
    },
    'youtubeClose':function(v){
    //  console.log('marketingmethod youtubeClose');
    //  console.log(v);

      let _tmpYoutubeType = v.split('_');

    //  console.log('_tmpYoutubeType');
    //  console.log(_tmpYoutubeType);

    //  console.log(typeof this.view_youtube);
    //  console.log(this.view_youtube);

      if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
        if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'method'){
          this.view_youtube = false
        }
      }

    //  console.log(typeof this.view_youtube);
    //  console.log(this.view_youtube);
    },
    'viewDatalistData.daily_budget':function(v){
    //  console.log('####');
    //  console.log(v);
    },
    'currencyListData':function(v){
      this.budgetKWInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.KW_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];

      this.budgetDMInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.DM_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];

      this.budgetLAInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.LA_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];

      this.budgetRTInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.RT_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
    },
    'viewDatalistData.Target_KW': function(v){
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      // console.log('watch viewDatalistData.page_id');
      // console.log(v);
      // console.log('this.goalsObjectiveData');
      // console.log(this.goalsObjectiveData);

      this.$emit('childTargetKW', v);

      if(v == true){
        // console.log('is true');
        if(this.goalsObjectiveData == 'CONVERSIONS' || this.goalsObjectiveData == 'LINK_CLICKS' || this.goalsObjectiveData == 'LEAD_GENERATION' || this.goalsObjectiveData == 'MESSAGES'){
          if(this.viewDatalistData.Budget_KW < this.currencyListData.KW_min_price){
            this.viewDatalistData.Budget_KW = this.currencyListData.KW_min_price

            this.budgetKWInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.KW_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
          } else {
            this.budgetKWInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.currency_suggest_price+this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_2'];
          }
        }

        if(this.goalsObjectiveData == 'POST_ENGAGEMENT' || this.goalsObjectiveData == 'LINK_CLICKS'){
          if(this.viewDatalistData.Budget_KW < this.currencyListData.KW_min_price){
            this.viewDatalistData.Budget_KW = this.currencyListData.KW_min_price

            this.budgetKWInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.KW_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
          } else {
            this.budgetKWInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.currency_suggest_price+this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_2'];
          }
        }

        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_CR = false;
        this.Budget_AD_min = '';
        this.Budget_AD_max = '';
        // this.viewDatalistData.daily_budget = 0

        let _tmpOtherCustomLength = this.otherCustomTitle.length;

        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      } else {
        this.viewDatalistData.Budget_KW = 0
      }

      this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF)

      //算最低預算比率
      // this.$emit('childBudgetKWTotal', this.viewDatalistData.Budget_KW);
    },
    'viewDatalistData.Target_DM': function(v){
      // console.log('watch viewDatalistData.page_id');
      // console.log(v);
    //  console.log(this.viewDatalistData);
    //  console.log(this.currencyListData);

      this.$emit('childTargetDM', v);

      if(v == true){
        if(this.viewDatalistData.Budget_DM < this.currencyListData.DM_min_price){
          // this.viewDatalistData.Budget_DM = this.currencyListData.DM_min_price

          this.budgetDMInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.DM_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
        } else {
          this.budgetDMInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.currency_suggest_price+this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_2'];
        }

        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_CR = false;
        this.Budget_AD_min = '';
        this.Budget_AD_max = '';
        // this.viewDatalistData.daily_budget = 0

        let _tmpOtherCustomLength = this.otherCustomTitle.length;

        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      } else {
        this.viewDatalistData.Budget_DM = 0
      }

    //  console.log('viewDatalistData.Target_DM');

      this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF)

    //  console.log('parseInt('+this.viewDatalistData.Budget_RT+') + parseInt('+this.viewDatalistData.Budget_DM+') + parseInt('+this.viewDatalistData.Budget_LA+') + parseInt('+this.viewDatalistData.Budget_KW+') + parseInt('+this.viewDatalistData.Budget_CF+')');

    //  console.log('this.viewDatalistData.daily_budget');
    //  console.log(this.viewDatalistData.daily_budget);
    },
    'viewDatalistData.Target_LA': function(v){
      // console.log('watch viewDatalistData.page_id');
      // console.log(v);

      this.$emit('childTargetLA', v);

      if(v == true){
        if(this.viewDatalistData.Budget_LA < this.currencyListData.LA_min_price){
          this.viewDatalistData.Budget_LA = this.currencyListData.LA_min_price

          this.budgetLAInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.LA_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
        }

        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_CR = false;
        this.Budget_AD_min = '';
        this.Budget_AD_max = '';
        // this.viewDatalistData.daily_budget = 0

        let _tmpOtherCustomLength = this.otherCustomTitle.length;

        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      } else {
        this.viewDatalistData.Budget_LA = 0
      }

      this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF)
    },
    'viewDatalistData.Target_RT': function(v){
      // console.log('watch viewDatalistData.page_id');
      // console.log(v);

      this.$emit('childTargetRT', v);

      if(v == true){
        if(this.viewDatalistData.Budget_RT < this.currencyListData.RT_min_price){
          // this.viewDatalistData.Budget_RT = this.currencyListData.RT_min_price

          this.budgetRTInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.RT_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
        }

        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_CR = false;
        this.Budget_AD_min = '';
        this.Budget_AD_max = '';
        this.viewDatalistData.daily_budget = 0

        let _tmpOtherCustomLength = this.otherCustomTitle.length;

        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      } else {
        this.viewDatalistData.Budget_RT = 0
      }

      this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF)
    },
    'viewDatalistData.Target_CF': function(v){
    //  console.log('viewDatalistData.Target_CF');
    //  console.log(v);

      this.$emit('childTargetCF', v);

      if(v == true){
        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_CR = false;
        this.Budget_AD_min = '';
        this.Budget_AD_max = '';
        // this.viewDatalistData.daily_budget = 0

        let _tmpOtherCustomLength = this.otherCustomTitle.length;

        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      } else {
        this.viewDatalistData.Budget_CF = 0
      }

      this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF)
    },
    'viewDatalistData.Target_AD': function(v){
    //  console.log('viewDatalistData.Target_AD');
    //  console.log(v);
    //  console.log(typeof v);
      if(v == true){
      //  console.log('is true')

        this.viewDatalistData.Target_KW = false;
        this.viewDatalistData.Target_DM = false;
        this.viewDatalistData.Target_LA = false;
        this.viewDatalistData.Target_RT = false;
        this.viewDatalistData.Target_CF = false;
        this.viewDatalistData.Target_CR = false;
        this.viewDatalistData.Target_AC = false;
        this.Budget_KW = '';
        this.Budget_DM = '';
        this.Budget_LA = '';
        this.Budget_RT = '';
        this.Budget_CF = '';
        this.Budget_AC = '';

        let _tmpOtherCustomLength = this.otherCustomTitle.length;

        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      } else {
        this.viewDatalistData.Budget_AD_min = 0
        this.viewDatalistData.Budget_AD_max = 0
      }

      this.$emit('childTargetAD', v);

    //  console.log('this.viewDatalistData.Budget_AD_max');
    //  console.log(this.viewDatalistData.Budget_AD_max);

      if(this.viewDatalistData.Budget_AD_max != '' && this.viewDatalistData.Budget_AD_max != null && typeof this.viewDatalistData.Budget_AD_max != 'undefined'){
        this.viewDatalistData.daily_budget = this.viewDatalistData.Budget_AD_max
      }

      // this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF)
    },
    'viewDatalistData.Target_CR': function(v){
    //  console.log('viewDatalistData.Target_CR');
    //  console.log(v);

      if(v == true){
      //  console.log('is true')

        this.viewDatalistData.Target_KW = false;
        this.viewDatalistData.Target_DM = false;
        this.viewDatalistData.Target_LA = false;
        this.viewDatalistData.Target_RT = false;
        this.viewDatalistData.Target_CF = false;
        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_AC = false;
        this.Budget_KW = '';
        this.Budget_DM = '';
        this.Budget_LA = '';
        this.Budget_RT = '';
        this.Budget_CF = '';
        this.Budget_AC = '';
        this.viewDatalistData.Budget_AD_min = 0;
        this.viewDatalistData.Budget_AD_max = 0;

        let _tmpOtherCustomLength = this.otherCustomTitle.length;

        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      }

      this.$emit('childTargetCR', v);
      this.$emit('childObjective', 'CONVERSIONS');

    //  console.log('b this.viewDatalistData.campaign_objective');
    //  console.log(this.viewDatalistData.campaign_objective);
      // this.goalsObjectiveData = 'CONVERSIONS';
      // this.viewDatalistData.campaign_objective = 'CONVERSIONS';
    //  console.log('a this.viewDatalistData.campaign_objective');
    //  console.log(this.viewDatalistData.campaign_objective);
    },
    'viewDatalistData.Budget_KW': function(v){
      // console.log('viewDatalistData.Budget_KW');
      // console.log(v);
      if(v > 0){
        this.Budget_KW = v
      } else {
        this.Budget_KW = ''
      }

      this.viewDatalistData.Budget_KW = v

      // if(this.viewDatalistData.Target_KW == true){
      //   if(this.goalsObjectiveData == 'CONVERSIONS' || this.goalsObjectiveData == 'LINK_CLICKS' || this.goalsObjectiveData == 'LEAD_GENERATION' || this.goalsObjectiveData == 'MESSAGES'){
      //     if(this.viewDatalistData.Budget_KW < 50){
      //       this.viewDatalistData.Budget_KW = 50
      //     }
      //   }

      //   if(this.goalsObjectiveData == 'POST_ENGAGEMENT' || this.goalsObjectiveData == 'LINK_CLICKS'){
      //     if(this.viewDatalistData.Budget_KW < 25){
      //       this.viewDatalistData.Budget_KW = 25
      //     }
      //   }
      // } else {
      //   this.viewDatalistData.Budget_KW = 0
      // }

      // this.viewDatalistData.daily_budget = parseInt(v) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_RT)
    },
    'viewDatalistData.Budget_DM': function(v){
      if(v > 0){
        this.Budget_DM = v
      } else {
        this.Budget_DM = ''
      }

      this.viewDatalistData.Budget_DM = v
      // if(this.viewDatalistData.Target_DM == true){
      //   if(this.viewDatalistData.Budget_DM < 50){
      //     this.viewDatalistData.Budget_DM = 50
      //   }
      // } else {
      //   this.viewDatalistData.Budget_DM = 0
      // }

      // this.viewDatalistData.daily_budget = parseInt(v) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_RT)
    },
    'viewDatalistData.Budget_LA': function(v){
      if(v > 0){
        this.Budget_LA = v
      } else {
        this.Budget_LA = ''
      }

      this.viewDatalistData.Budget_LA = v
      // if(this.viewDatalistData.Target_LA == true){
      //   if(this.viewDatalistData.Budget_LA < 50){
      //     this.viewDatalistData.Budget_LA = 50
      //   }
      // } else {
      //   this.viewDatalistData.Budget_LA = 0
      // }

      // this.viewDatalistData.daily_budget = parseInt(v) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_RT)
    },
    'viewDatalistData.Budget_RT': function(v){
      if(v > 0){
        this.Budget_RT = v
      } else {
        this.Budget_RT = ''
      }

      this.viewDatalistData.Budget_RT = v
      // if(this.viewDatalistData.Target_RT == true){
      //   if(this.viewDatalistData.Budget_RT < 15){
      //     this.viewDatalistData.Budget_RT = 15
      //   }
      // } else {
      //   this.viewDatalistData.Budget_RT = 0
      // }

      // this.viewDatalistData.daily_budget = parseInt(v) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW)
    },
    'viewDatalistData.Budget_CF': function(v){
      if(v > 0){
        this.Budget_CF = v
      } else {
        this.Budget_CF = ''
      }

      this.viewDatalistData.Budget_CF = v
    },
    'viewDatalistData.Budget_AD_min': function(v){
      if(v > 0){
        this.Budget_AD_min = v
      } else {
        this.Budget_AD_min = ''
      }

      this.viewDatalistData.Budget_AD_min = v
    },
    'viewDatalistData.Budget_AD_max': function(v){
      if(v > 0){
        this.Budget_AD_max = v
      } else {
        this.Budget_AD_max = ''
      }

      this.viewDatalistData.Budget_AD_max = v
      // this.viewDatalistData.daily_budget = v
    },
    'viewDatalistData.Target_AC': function(v){
      console.log('viewDatalistData.Target_AC');
      console.log(v);

      this.$emit('childTargetAC', v);

      if(v == true){
        // 與 AD/CR 互斥
        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_CR = false;
        this.Budget_AD_min = '';
        this.Budget_AD_max = '';

        let _tmpOtherCustomLength = this.otherCustomTitle.length;
        if(_tmpOtherCustomLength > 0){
          for(let i = 0; i < _tmpOtherCustomLength; i++){
            this.otherCustomTitle[i].selected = false;
          }
        }
      } else {
        this.viewDatalistData.Budget_AC = 0;
      }

      this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF) + parseInt(this.viewDatalistData.Budget_AC || 0);
    },
    'viewDatalistData.Budget_AC': function(v){
      if(v > 0){
        this.Budget_AC = v;
      } else {
        this.Budget_AC = '';
      }
      this.viewDatalistData.Budget_AC = v;
    }
  },
  methods: {
    onReady() {
    //  console.log('youtube');
      this.$refs.youtube.playVideo()
      // this.$refs.youtube.pauseVideo()
    },
    onStateChange(e){
    //  console.log(e);

      if(e.data == 0){
        this.view_youtube = false
      }
    },
    teachVideo(){
      this.$emit('checkClose')
      // let elem = document.getElementById('marketingMethod');
      // let positio = this.getPosition(elem);
      // console.log('x:'+positio.x);
      // console.log('y:'+positio.y);

      // this.x = positio.x + parseInt(80);
      // this.y = positio.y

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // console.log('windowWidth');
      // console.log(windowWidth);
      // console.log('windowHeight');
      // console.log(windowHeight);

      this.x = windowWidth - parseInt(390);
      this.y = windowHeight - parseInt(350);

      this.view_youtube = true;
      this.$emit('childYoutube', 'true_method')

      this.src = "https://www.youtube.com/watch?v=VMMjP-UF6BY"
      this.vars.start = 24
      this.vars.end = 134
    },
    getPosition(element) {
      let x = 0;
      let y = 0;

      while ( element ) {
        x += element.offsetLeft - element.scrollLeft + element.clientLeft;
        y += element.offsetTop - element.scrollLeft + element.clientTop;
        element = element.offsetParent;
      }

      return { x: x, y: y };
    },
    print(val) {
    //  console.log(val)
    },
    doDragging(){
    //  console.log('doDragging');
    },
    budgetKW(value){
      // console.log('budgetKW');
      // console.log(value);
      // console.log('this.currencyListData.KW_min_price');
      // console.log(this.currencyListData.KW_min_price);
      if(this.viewDatalistData.Target_KW == true){
        // if(this.goalsObjectiveData == 'CONVERSIONS' || this.goalsObjectiveData == 'LINK_CLICKS' || this.goalsObjectiveData == 'LEAD_GENERATION' || this.goalsObjectiveData == 'MESSAGES'){
          if(value < this.currencyListData.KW_min_price){
            this.viewDatalistData.Budget_KW = this.currencyListData.KW_min_price
            this.Budget_KW = this.currencyListData.KW_min_price
            value = this.currencyListData.KW_min_price

            this.budgetKWInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.KW_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
          } else {
            this.viewDatalistData.Budget_KW = value
            this.Budget_KW = value
            this.budgetKWInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.currency_suggest_price+this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_2'];
          }
        // }

        // if(this.goalsObjectiveData == 'POST_ENGAGEMENT' || this.goalsObjectiveData == 'LINK_CLICKS'){
        //   if(value < this.currencyListData.KW_min_price){
        //     this.viewDatalistData.Budget_KW = this.currencyListData.KW_min_price
        //     value = this.currencyListData.KW_min_price

        //     this.budgetKWInfo = "至少要"+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.KW_min_price+" 以上";
        //   } else {
        //     this.budgetKWInfo = "建議設定在"+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.suggest_price+" 以上，成效表現更好";
        //   }
        // }
      } else {
        this.viewDatalistData.Budget_KW = 0
        value = 0
      }

      this.viewDatalistData.daily_budget = parseInt(value) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_CF)

      //算最低預算比率

      // this.$emit('childBudgetKWTotal', value)
    },
    budgetDM(value){
    //  console.log('budgetDM(value)');
    //  console.log(this.currencyListData);
      if(this.viewDatalistData.Target_DM == true){
        if(value < this.currencyListData.DM_min_price){
          this.viewDatalistData.Budget_DM = this.currencyListData.DM_min_price
          this.Budget_DM = this.currencyListData.DM_min_price
          value = this.currencyListData.DM_min_price

          this.budgetDMInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.DM_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
        } else {
          this.viewDatalistData.Budget_DM = value
          this.Budget_DM = value
          this.budgetDMInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.currency_suggest_price+this.lang['components']['Event']['MarketingMethod']['export_default']['suggest_info_2'];
        }
      } else {
        this.viewDatalistData.Budget_DM = 0
        value = 0
      }

      this.viewDatalistData.daily_budget = parseInt(value) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_CF)
    },
    budgetLA(value){
      if(this.viewDatalistData.Target_LA == true){
        if(value < this.currencyListData.LA_min_price){
          this.viewDatalistData.Budget_LA = this.currencyListData.LA_min_price
          this.Budget_LA = this.currencyListData.LA_min_price
          value = this.currencyListData.LA_min_price

          this.budgetLAInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.LA_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
        } else {
          this.viewDatalistData.Budget_LA = value
          this.Budget_LA = value
        }
      } else {
        this.viewDatalistData.Budget_LA = 0
        value = 0
      }

      this.viewDatalistData.daily_budget = parseInt(value) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_CF)
    },
    budgetRT(value){
      if(this.viewDatalistData.Target_RT == true){
        if(value < this.currencyListData.RT_min_price){
          this.viewDatalistData.Budget_RT = this.currencyListData.RT_min_price
          this.Budget_RT = this.currencyListData.RT_min_price
          value = this.currencyListData.RT_min_price

          this.budgetRTInfo = this.lang['components']['Event']['MarketingMethod']['export_default']['info_1']+this.currencyListData.currency+"("+this.currencyListData.currency_symbol+")"+this.currencyListData.RT_min_price+this.lang['components']['Event']['MarketingMethod']['export_default']['info_2'];
        } else {
          this.viewDatalistData.Budget_RT = value
          this.Budget_RT = value
        }
      } else {
        this.viewDatalistData.Budget_RT = 0
        value = 0
      }

      this.viewDatalistData.daily_budget = parseInt(value) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_CF)
    },
    budgetCF(value){
      if(this.viewDatalistData.Target_CF == true){
        this.viewDatalistData.Budget_CF = value
          this.Budget_CF = value
      } else {
        this.viewDatalistData.Budget_CF = 0
        value = 0
      }

      this.viewDatalistData.daily_budget = parseInt(value) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_KW)
    },
    budgetAD_min(value){
      if(this.viewDatalistData.Target_AD == true){
        this.viewDatalistData.Budget_AD_min = value
          this.Budget_AD_min = value
      } else {
        this.viewDatalistData.Budget_AD_min = 0
        value = 0
      }
    },
    budgetAD_max(value){
      if(this.viewDatalistData.Target_AD == true){
        this.viewDatalistData.Budget_AD_max = value
          this.Budget_AD_max = value
      } else {
        this.viewDatalistData.Budget_AD_max = 0
        value = 0
      }

      this.viewDatalistData.daily_budget = parseInt(value)
    },
    budgetAC(value){
      if(this.viewDatalistData.Target_AC == true){
        this.viewDatalistData.Budget_AC = value;
        this.Budget_AC = value;
      } else {
        this.viewDatalistData.Budget_AC = 0;
        value = 0;
      }
      this.viewDatalistData.daily_budget = parseInt(this.viewDatalistData.Budget_KW) + parseInt(this.viewDatalistData.Budget_DM) + parseInt(this.viewDatalistData.Budget_LA) + parseInt(this.viewDatalistData.Budget_RT) + parseInt(this.viewDatalistData.Budget_CF) + parseInt(value);
    },
    budgetCR(value){
    //  console.log('budgetCR');
    },
    openTeaching(){
      this.$emit('childOpenTeaching', 1)
    },
    selectedOtherCust(status, index){
    //  console.log('selectedOtherCust');
    //  console.log(status +'|'+ index);

      let _tmpOtherCustomLength = this.otherCustomTitle.length;

      if(status == true){
        for(let i = 0; i < _tmpOtherCustomLength; i++){
          this.otherCustomTitle[i].selected = false;
        }

        this.viewDatalistData.Target_KW = false;
        this.viewDatalistData.Target_DM = false;
        this.viewDatalistData.Target_LA = false;
        this.viewDatalistData.Target_RT = false;
        this.viewDatalistData.Target_CF = false;
        this.viewDatalistData.Target_AD = false;
        this.viewDatalistData.Target_CR = false;

        this.otherCustomTitle[index].selected = true;

        this.$emit('childOtherCustom', status+'_'+index);
      }

    //  console.log(this.otherCustomTitle);
    },
    hideCustom(title, id, selected){
    //  console.log('hideCustom');
    //  console.log(title);
    //  console.log(id);
    //  console.log(selected);

      if(selected == false){
      //  console.log('未勾選');
        this.$emit('childHideCustom', title+'|||'+id);
      }
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    currencyListData: {
      get: function () {
        return this.currencyList
      },
      set: function (value) {
        this.$emit('update:currencyListData', value)
      },
    },
    goalsObjectiveData: {
      get: function () {
        return this.goalsObjective
      },
      set: function (value) {
        this.$emit('update:goalsObjectiveData', value)
      },
    }
  }
};
</script>
<style lang="scss" scope>
.remarketing {
  .p-multiselect-label-container {
    display: none;
  }
}
</style>
